<div class="bkg">

    <div class="row m-0" style="margin: 0; padding: 0;">
        <div class="col-4" style="margin: 0; padding: 0;">
            <div *ngFor="let nav of lstSideNav; let i=index" class='side-nav' [ngStyle]="{'background-color':nav.color}"
                (click)="currentIndex=i;" [ngClass]="{'active-window':i==currentIndex}">
                <p class="side-nav-text" [innerHtml]="nav.text" data-aos="fade-left">
                </p>
            </div>
        </div>

        <div class="col-8" style="background-color: #FFFFFF;">
            <div>
                <p class='top-text' [innerHtml]="lstWindows[currentIndex].firstText" data-aos="flip-left">
                </p>
                <div class="header-colorfull-wrap" data-aos="flip-left">
                    <p class="header-colorfull-text" [innerHtml]="lstWindows[currentIndex].colorfullHeader">
                    </p>
                </div>
                <div class="text" [innerHtml]="lstWindows[currentIndex].secondText" data-aos="flip-left">
                </div>
                <div class="row wrap-all-box d-flex justify-content-center"
                    *ngFor="let rowBox of lstWindows[currentIndex].lstRowBox">
                    <div *ngFor="let box of rowBox" class="box">
                        <div class="img-wrap" data-aos="flip-left" data-aos-duration="1500">
                            <img class="img" [src]="baseURL+box.imgUrl">
                        </div>
                        <p class="text" data-aos="fade-up">{{box.text}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>